import { formatMoveBackwardAvailableForSeconds } from './formatMoveBackwardAvailableForSeconds';

type Params = {
    canMoveForward: boolean;
    canMoveBackward: boolean;
    moveBackwardAvailableForSeconds: number;
};

export function getDashboardTodoListStepNavigationCaption(params: Params): string {
    const { canMoveForward, canMoveBackward, moveBackwardAvailableForSeconds } = params;
    const remaining = formatMoveBackwardAvailableForSeconds(moveBackwardAvailableForSeconds);

    if (canMoveBackward && remaining !== '') {
        return `К предыдущему этапу можно вернуться в течение ${remaining}`;
    }

    if (canMoveForward) {
        return 'Доступны новые рекомендации: можно завершить текущие шаги или перейти дальше';
    }

    return '';
}
